import { httpInstance } from '@/services/httpInstance';

const getDocumentById = async (documentId) => {
  const endpoint = `/back-office/v1/rootness-document/${documentId}`;
  let res;
  await httpInstance.get(
    endpoint,
  ).then((dataResponse) => {
    res = dataResponse;
  }).catch((err) => {
    res = err.response;
  });
  return res;
};

export default getDocumentById;
